import "./PersonItem.scss";
import { useTranslation } from "react-i18next";

// Role values come from the server - only how they are displayed is translated
const ROLE_LABEL_KEYS = {
  owner: "people.roles.owner",
  admin: "people.roles.admin",
  member: "people.roles.member",
  pending: "people.roles.pending",
};

// Can have 3 colors: Pending (gray), Collaborator (blue), Admin (green)
function PersonItem({
  name,
  role,
  onClick,
  isSelected,
  showDelete,
  onDelete,
  isCurrentUser,
}) {
  const { t } = useTranslation();

  const handleDeleteClick = (e) => {
    e.stopPropagation(); // Prevent triggering onClick
    if (onDelete) {
      onDelete();
    }
  };

  return (
    <div
      className={`person-item ${isSelected ? "selected" : ""} ${isCurrentUser ? "current-user" : ""}`}
      onClick={onClick}
    >
      <div className={`role-indicator ${role}`}></div>
      <div className="person-info">
        <span className="person-name">{name}</span>
        {role !== "user" && role !== "member" && (
          <span className="role-label">
            ({ROLE_LABEL_KEYS[role] ? t(ROLE_LABEL_KEYS[role]) : role})
          </span>
        )}
      </div>
      {showDelete && (
        <button className="delete-button" onClick={handleDeleteClick}>
          <span className="material-symbols-outlined">person_remove</span>
        </button>
      )}
    </div>
  );
}

export default PersonItem;
